/**
 * WordPress dependencies
 */
import { useState, useEffect, useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";

import PatternContext from '../Context/PatternContext';

const PatternlySearchbox = () => {

    const patternContext = useContext(PatternContext);

    const searchPatterns = (event) => {
        let searchValue = event.currentTarget.value;

        if(searchValue.length > 0 && searchValue.length < 3) {
            return;
        }

        //remove category active class.
        let activeCategoryItem = document.querySelector('.pat-sidebar-active');
        activeCategoryItem.classList.remove('pat-sidebar-active');

        let firstCatItem = document.querySelector('.pat-sidebar-ul li:first-child');
        firstCatItem.classList.add('pat-sidebar-active');

        //reset favourite values.
        patternContext.setFavouriteValue(false);

        if(searchValue.length === 0) {
            patternContext.setSearchValue(false);
            patternContext.setQueryType('all');

            patternContext.setCurrentPage(1);
            patternContext.setLoadData(true);
            patternContext.setLoadMoreButton(true);
        }else {
            patternContext.setSearchValue(searchValue);
            patternContext.setQueryType(false);

            patternContext.setCurrentPage(1);
            patternContext.setLoadData(true);
            patternContext.setLoadMoreButton(true);
        }
    };

    return (
        <>
            <div class="pat-searchbox-wrap">
                <label>
                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/search.png`} alt="" />
                    <input class="pat-search-box" type="text" onChange={searchPatterns} placeholder={__('Search', 'patternly')} />
                </label>
            </div>
        </>
    );
};

export default PatternlySearchbox;